__turbopack_context__.v({
  "dots": "Slideshow-module-scss-module__TBrfKG__dots",
  "fade-in": "Slideshow-module-scss-module__TBrfKG__fade-in",
  "fade-out": "Slideshow-module-scss-module__TBrfKG__fade-out",
  "image": "Slideshow-module-scss-module__TBrfKG__image",
  "isActive": "Slideshow-module-scss-module__TBrfKG__isActive",
  "isPrevious": "Slideshow-module-scss-module__TBrfKG__isPrevious",
  "isSlideshow": "Slideshow-module-scss-module__TBrfKG__isSlideshow",
  "nav": "Slideshow-module-scss-module__TBrfKG__nav",
  "root": "Slideshow-module-scss-module__TBrfKG__root",
});
